import { createApi } from '@reduxjs/toolkit/query/react'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const packagesApiService = createApi({
    reducerPath: 'packagesApi',
    baseQuery: createNeighborhoodAwareBaseQuery('/package/'),
    endpoints: (builder) => ({
        getPackages: builder.query({
            query: (args) => ({
                url: args?.id ? `get/${args?.id}` : "get",
                method: "GET",
                params: args?.id ? {} : args
            }),
            keepUnusedDataFor: 0
        }),
        createPackages: builder.mutation({
            query: (body) => ({
                url: `create`,
                method: "POST",
                body
            })
        }),
        getPaymentLogs: builder.query({
            query: (args) => ({
                url: "/payment-logs",
                method: "GET",
                params: args
            }),
            keepUnusedDataFor: 0
        }),
        deletePromotion: builder.mutation({
            query: (id) => ({
                url: `delete/${id}`,
                method: "DELETE"
            })
        }),
        updatePromotion: builder.mutation({
            query: (body) => ({
                url: `update/${body?._id}`,
                method: "PUT",
                body
            })
        })
    })
})

export const {
    useGetPackagesQuery,
    useCreatePackagesMutation,
    useGetPaymentLogsQuery,
    useDeletePromotionMutation,
    useUpdatePromotionMutation
} = packagesApiService
